export default [
  {
    title: "Survey and Quiz",
    customIcon: "SurveySvg",
    children: [
      {
        title: "Survey",
        route: "custom-survey-list",
        path: "/custom-survey/survey-list",
      },
      {
        title: "Quiz",
        route: "custom-quiz-list",
        path: "/custom-quiz/quiz-list",
      },
    ],
  },
];